// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"316":"ad2866b8","501":"bc98253f"}[chunkId] || chunkId) + "." + {"199":"e5214492dc2b9fad","316":"fa3eb43ebdf7204f","501":"465d18846a0ab06e","931":"04471df85278df81"}[chunkId] + ".js";
};